import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

// The date cannot be in the past and cannot be more than one year after initiation.

export function yousignUnterschriftBisValidator(): ValidatorFn {
	return (control: AbstractControl): ValidationErrors | null => {
		const value = control.value as string;

		if (!value) {
			return null;
		}

		const date = new Date(value);
		if (isNaN(date.getTime())) {
			return { invalidDate: true };
		}

		// Heute, auf Mitternacht gerundet.
		const today = new Date();
		today.setHours(0, 0, 0, 0);

		// Maximal ein Jahr in der Zukunft.
		const maxDate = new Date(today);
		maxDate.setFullYear(maxDate.getFullYear() + 1);

		if (date < today) {
			// Datum in der Vergangenheit.
			return { dateInPast: true };
		}

		if (date > maxDate) {
			// Datum mehr als ein Jahr in der Zukunft.
			return { dateTooFarInFuture: true };
		}

		// Alles gut
		return null;
	};
}
